import React, { Component } from 'react';
import PropTypes from 'prop-types';


class ExecutionReportDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isDataAvailable: false
        }
    }

    render() {
        return (
            <div data-test = 'closedLoopPerformanceReportExecutionReportDetailsComponent'>
                { Object.keys(this.props.executionInfo).length > 0 ?
                 <div className='row'>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table'>
                                    <thead>
                                        <tr className="table-head" valign="middle" align="middle">
                                            {/* <th scope="col" key="date" style={{ textAlign: "center" }}>Date</th> */}
                                            <th scope="col" key="scenarioGroupFolder" style={{ textAlign: "center" }}>Scenario Group Folder</th>
                                            <th scope="col" key="totalNumberOfScenarios" style={{ textAlign: "center" }}>Total Number Of Scenarios</th>
                                            <th scope="col" key="succeededScenarios" style={{ textAlign: "center" }}>Succeeded Scenarios</th>
                                            <th scope="col" key="failedScenarios" style={{ textAlign: "center" }}>Failed Scenarios</th>
                                            {/* <th scope="col" key="totalExecutionTime" style={{ textAlign: "center" }}>Total Execution Time (s)</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr key="1" valign="middle" className="table-row" style={{ verticalAlign: "text-top" }}>
                                            {/* <td>{ this.props.executionInfo['date'] }</td> */}
                                            <td>{ this.props.executionInfo['scenario_group_folder'] }</td>
                                            <td>{ this.props.executionInfo['total_number_of_scenarios'] }</td>
                                            <td>{ this.props.executionInfo['number_of_successfully_completed_scenarios'] }</td>
                                            <td>{ this.props.executionInfo['number_of_failed_scenario_executions'] }</td>
                                            {/* <td>{ this.props.executionInfo['total_execution_time'] }</td> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='row' style={{ paddingTop: '2%' }}>
                            <div className='col-12'>
                                <table className='table'>
                                    <thead>
                                        <tr className="table-head" valign="middle" align="middle">
                                            <th scope="col" key="averageExecutionTime" style={{ textAlign: "center" }}>Average Execution Time (s)</th>
                                            <th scope="col" key="minimumTimeTaken" style={{ textAlign: "center" }}>Minimum Time Taken (s)</th>
                                            <th scope="col" key="maximumTimeTaken" style={{ textAlign: "center" }}>Maximum Time Taken (s)</th>
                                            {/* <th scope="col" key="scenarioRunnerTime" style={{ textAlign: "center" }}>Scenario Runner Time (s)</th> */}
                                            <th scope="col" key="scenarioGroupSize" style={{ textAlign: "center" }}>Scenario Group Size (MB)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr key="1" valign="middle" className="table-row" style={{ verticalAlign: "text-top" }}>
                                            <td>{ this.props.executionInfo['average_execution_time'] }</td>
                                            <td>{ this.props.executionInfo['minimum_time_taken_by_a_scenario'] }</td>
                                            <td>{ this.props.executionInfo['maximum_time_taken_by_a_scenario'] }</td>
                                            {/* <td>{ this.props.executionInfo['scenario_runner_time'] }</td> */}
                                            <td>{ this.props.executionInfo['scenario_group_size'] }</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className='row' style={{ paddingTop: '2%' }}>
                            <div className='col-12'>
                                <table className='table'>
                                    <thead>
                                        <tr className="table-head" valign="middle" align="middle">
                                            <th scope="col" key="startExecutionTime" style={{ textAlign: "center" }}>Instance Execution - Start Time</th>
                                            <th scope="col" key="endExecutionTime" style={{ textAlign: "center" }}>Instance Execution - End Time</th>
                                            <th scope="col" key="terminationExecutionTime" style={{ textAlign: "center" }}>Instance Execution - Termination Time</th>
                                            <th scope="col" key="instanceExecutionTime" style={{ textAlign: "center" }}>Total Instance Execution Time</th>
                                            <th scope="col" key="terminationTime" style={{ textAlign: "center" }}>Time taken to Terminate the Instance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr key="1" valign="middle" className="table-row" style={{ verticalAlign: "text-top" }}>
                                            <td>{ this.props.executionInfo['execution_start_time'] }</td>
                                            <td>{ this.props.executionInfo['execution_end_time'] }</td>
                                            <td>{ this.props.executionInfo['execution_termination_time'] }</td>
                                            <td>{ this.props.executionInfo['total_instance_execution_time'] }</td>
                                            <td>{ this.props.executionInfo['time_taken_to_terminate_after_execution'] }</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                 </div>
                 :<div className='row'>
                    <div className='col-12'>
                        <div className="alert alert-danger" role="alert">
                            No Data Available
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}
ExecutionReportDetails.propTypes={
executionInfo:PropTypes.string,
//count:PropTypes.string,
//dispatch:PropTypes.string,
//items:PropTypes.string,
}
ExecutionReportDetails.defaultProps= {
executionInfo:[],
//count:[],
//dispatch:[],
//items:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default ExecutionReportDetails;
